export const getArraysDifference = (
    arr1: Array<string | number>,
    arr2: Array<string | number>,
) => {
    return arr1
        .filter((x) => !arr2.includes(x))
        .concat(arr2.filter((x) => !arr1.includes(x)));
};

export const arrayAddIf = (condition: boolean, value: any) => {
    if (condition) {
        return Array.isArray(value) ? value : [value];
    }
    return [];
};

export const filteredArray = (arr: any[], filterFalseValue = false) => {
    return arr.filter(
        (val) =>
            val !== undefined &&
            val !== null &&
            (filterFalseValue ? !!val : true),
    );
};

export const mapToLabelValue = (array: string[]) => {
    return array?.map((item) => ({
        label: item,
        value: item
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^a-z0-9-]/g, ""),
    }));
};

export const getJoinedStringFromArray = (
    arr: any[],
    separator = ", ",
    filterItem = true,
) => {
    let _ = arr;
    if (filterItem) {
        _ = filteredArray(arr, filterItem);
    }
    return _.join(separator);
};

export function toggleArrayValue<T>(array: T[], value: T): T[] {
    const index = array.indexOf(value);

    if (index === -1) {
        // Value does not exist in array, add it
        return [...array, value];
    } else {
        // Value exists in array, remove it
        return array.filter((item) => item !== value);
    }
}

export function getUniqueArray<T>(arr: T[]): T[] {
    return Array.from(new Set(arr));
}
